export default __webpack_public_path__ + "static/media/episode2VideoBgM.c428159a.jpg";